import { toast } from "react-toastify";

import { ImageDTO, ImagesApi, Configuration } from "@app/api/generated";
import JWTToken from "@app/authorization/jwt-token";
import { getConfig } from "@app/util";

export const uploadImage = async (file: any): Promise<ImageDTO | undefined> => {
  try {
    const api = new ImagesApi(
      new Configuration({
        basePath: getConfig().API_URL,
        headers: {
          "x-access-token": JWTToken.getToken("accessToken")
        }
      })
    );

    const formData = new FormData();
    formData.append("file", file);

    const result = await api.create({ body: formData });

    return result;
  } catch (error) {
    toast.error("Image upload failed");
  }

  return undefined;
};
